/* Version: 3.5.155 */
'use client';
import styled from 'styled-components';
import { typography } from '../../typography/typography.js';

var LabelWrapper = /*#__PURE__*/styled.label.withConfig({
  displayName: "styledComponents__LabelWrapper",
  componentId: "sc-hjijhx-0"
})(["font-family:", ";font-size:", ";line-height:", ";font-weight:", ";color:", ";display:block;margin-bottom:8px;cursor:", ";& .mux-Label-Tooltip{margin-left:6px;}", " &:has(input[type='checkbox']),&:has(input[type='radio']){display:flex;align-items:center;font-weight:", ";cursor:pointer;}&:has(input[type='checkbox']:checked),&:has(input[type='checkbox'][data-indeterminate='true']),&:has(input[type='radio']:checked){font-weight:", ";}&:has(input[type='checkbox']:disabled),&:has(input[type='radio']:disabled){color:", ";cursor:not-allowed;}"], typography.fontFamily, typography.fontSize, typography.lineHeight, typography.fontWeightDemibold, function (_ref) {
  var isDisabled = _ref.isDisabled,
    theme = _ref.theme;
  return isDisabled ? theme.colorPalette.neutralColors.dark.shade_light_4 : theme.colorPalette.neutralColors.dark.shade_light_1;
}, function (_ref2) {
  var isDisabled = _ref2.isDisabled,
    showPointer = _ref2.showPointer;
  if (isDisabled) {
    return 'not-allowed';
  }
  if (showPointer) {
    return 'pointer';
  }
  return 'default';
}, function (_ref3) {
  var labelStyle = _ref3.labelStyle;
  return labelStyle;
}, typography.fontWeightLight, typography.fontWeightNormal, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colorPalette.neutralColors.dark.shade_light_4;
});
process.env.NODE_ENV !== "production" ? LabelWrapper.displayName = 'LabelWrapper' : undefined;

export { LabelWrapper, LabelWrapper as default };
